import React, { useEffect, useState } from 'react';
import { httpsCallable } from 'firebase/functions';
import { functions, IS_HOMOLOGACAO } from '../firebase';

const MODELOS_PADRAO = {
  verificacao: {
    assunto: 'Confirme seu e-mail no PromoAlert',
    corpo: '<p>Olá, %DISPLAY_NAME%.</p><p>Confirme seu e-mail no PromoAlert clicando no link abaixo:</p><p><a href="%LINK%">Confirmar meu e-mail</a></p><p>Se não foi você, ignore esta mensagem.</p>',
  },
  redefinicaoSenha: {
    assunto: 'Redefina sua senha do PromoAlert',
    corpo: '<p>Olá, %DISPLAY_NAME%.</p><p>Recebemos uma solicitação para redefinir sua senha. Use o link abaixo:</p><p><a href="%LINK%">Redefinir minha senha</a></p><p>Se não foi você, ignore esta mensagem.</p>',
  },
};

const CONFIGURACAO_INICIAL = {
  habilitado: false,
  remetente: '',
  responderPara: '',
  urlAcao: '',
  smtp: {
    autenticacao: 'senha',
    host: '',
    porta: 587,
    seguranca: 'starttls',
    usuario: '',
    senhaConfigurada: false,
    microsoft: { tenantId: '', clientId: '', credencialConfigurada: false },
  },
  modelos: MODELOS_PADRAO,
};

function montarConfiguracao(data = {}) {
  return {
    ...CONFIGURACAO_INICIAL,
    ...data,
    smtp: {
      ...CONFIGURACAO_INICIAL.smtp,
      ...(data.smtp || {}),
      microsoft: { ...CONFIGURACAO_INICIAL.smtp.microsoft, ...(data.smtp?.microsoft || {}) },
    },
    modelos: {
      verificacao: { ...MODELOS_PADRAO.verificacao, ...(data.modelos?.verificacao || {}) },
      redefinicaoSenha: { ...MODELOS_PADRAO.redefinicaoSenha, ...(data.modelos?.redefinicaoSenha || {}) },
    },
  };
}

function AbaConfiguracaoEmail({ somenteConsulta = false }) {
  const [configuracao, setConfiguracao] = useState(CONFIGURACAO_INICIAL);
  const [senhaSmtp, setSenhaSmtp] = useState('');
  const [carregando, setCarregando] = useState(true);
  const [salvando, setSalvando] = useState(false);
  const [testando, setTestando] = useState(false);
  const [retorno, setRetorno] = useState(null);
  const [alterado, setAlterado] = useState(false);
  const usaMicrosoft = configuracao.smtp.autenticacao === 'microsoft_oauth';
  const credencialConfigurada = usaMicrosoft ? configuracao.smtp.microsoft.credencialConfigurada : configuracao.smtp.senhaConfigurada;

  useEffect(() => {
    let ativo = true;
    const carregar = async () => {
      try {
        const resposta = await httpsCallable(functions, 'obterConfiguracaoEmailPainel')();
        if (ativo) setConfiguracao(montarConfiguracao(resposta.data?.configuracao));
      } catch (error) {
        if (ativo) {
          setRetorno({ tipo: 'erro', mensagem: error.message || 'Não foi possível carregar a configuração de e-mail.' });
        }
      } finally {
        if (ativo) setCarregando(false);
      }
    };

    carregar();
    return () => { ativo = false; };
  }, []);

  const atualizarCampo = (campo, valor) => {
    setAlterado(true);
    setConfiguracao((atual) => ({ ...atual, [campo]: valor }));
  };

  const atualizarSmtp = (campo, valor) => {
    setAlterado(true);
    setConfiguracao((atual) => ({ ...atual, smtp: { ...atual.smtp, [campo]: valor } }));
  };

  const atualizarMicrosoft = (campo, valor) => {
    setAlterado(true);
    setConfiguracao((atual) => ({ ...atual, smtp: { ...atual.smtp, microsoft: { ...atual.smtp.microsoft, [campo]: valor } } }));
  };

  const mudarAutenticacao = (valor) => {
    setAlterado(true);
    setSenhaSmtp('');
    setConfiguracao((atual) => ({
      ...atual,
      smtp: {
        ...atual.smtp,
        autenticacao: valor,
        ...(valor === 'microsoft_oauth' ? { host: 'smtp.office365.com', porta: 587, seguranca: 'starttls' } : {}),
      },
    }));
  };

  const atualizarModelo = (modelo, campo, valor) => {
    setAlterado(true);
    setConfiguracao((atual) => ({
      ...atual,
      modelos: {
        ...atual.modelos,
        [modelo]: { ...atual.modelos[modelo], [campo]: valor },
      },
    }));
  };

  const salvar = async () => {
    setSalvando(true);
    setRetorno(null);
    try {
      const resposta = await httpsCallable(functions, 'salvarConfiguracaoEmailPainel')({
        configuracao,
        senhaSmtp: senhaSmtp || undefined,
      });
      setConfiguracao(montarConfiguracao(resposta.data?.configuracao));
      setSenhaSmtp('');
      setAlterado(false);
      setRetorno({ tipo: 'sucesso', mensagem: 'Configuração de e-mail salva com segurança.' });
    } catch (error) {
      setRetorno({ tipo: 'erro', mensagem: error.message || 'Não foi possível salvar a configuração de e-mail.' });
    } finally {
      setSalvando(false);
    }
  };

  const enviarTeste = async () => {
    setTestando(true);
    setRetorno(null);
    try {
      const resposta = await httpsCallable(functions, 'enviarTesteEmailPainel')();
      setRetorno({ tipo: 'sucesso', mensagem: `E-mail de teste aceito pelo servidor para ${resposta.data?.destinatario || 'o administrador logado'}. Confira a caixa de entrada e o spam. O teste não ativa o envio para usuários.` });
    } catch (error) {
      setRetorno({ tipo: 'erro', mensagem: error.message || 'Não foi possível enviar o e-mail de teste.' });
    } finally {
      setTestando(false);
    }
  };

  if (carregando) {
    return <p className="routine-callout__text">Carregando configuração de e-mail...</p>;
  }

  return (
    <section className="routine-surface admin-surface-section">
      <div className="routine-title-group" style={{ marginBottom: '16px' }}>
        <p className="dashboard-section__eyebrow">Comunicação</p>
        <h4 className="routine-section-title">E-mail transacional</h4>
        <p className="routine-section-subtitle">
          Configure o envio e os modelos de verificação e recuperação de senha. Credenciais ficam no Secret Manager, nunca no Firestore nem nas respostas do painel.
        </p>
      </div>

      {IS_HOMOLOGACAO && (
        <div className="routine-callout routine-callout--warm" style={{ marginBottom: '16px' }}>
          <h5 className="routine-callout__title">Homologação sem credencial de envio</h5>
          <p className="routine-callout__text" style={{ marginTop: '8px' }}>
            Este ambiente pode validar a tela e os modelos, mas deve permanecer sem envio ativo. A credencial oficial fica somente no Secret Manager de produção.
          </p>
        </div>
      )}

      <fieldset disabled={somenteConsulta || salvando || testando} style={{ border: 0, padding: 0, margin: 0 }}>
        <div className="admin-grid-2">
          <label className="admin-checkbox-item">
            <input
              type="checkbox"
              checked={Boolean(configuracao.habilitado)}
              onChange={(event) => atualizarCampo('habilitado', event.target.checked)}
            />
            <span>Usar SMTP próprio para e-mails do aplicativo</span>
          </label>
          <div className="routine-callout">
            <p className="routine-callout__text">
              {usaMicrosoft ? 'Credencial Microsoft 365' : 'Senha SMTP'}: <strong>{credencialConfigurada ? 'configurada no Secret Manager' : 'não configurada'}</strong>.
            </p>
          </div>
        </div>

        <div className="admin-grid-2" style={{ marginTop: '16px' }}>
          <div className="routine-field">
            <label className="routine-label">Endereço do remetente</label>
            <input className="routine-input" type="email" value={configuracao.remetente} onChange={(event) => atualizarCampo('remetente', event.target.value)} placeholder="noreply@mail.sistemasvms.com.br" />
          </div>
          <div className="routine-field">
            <label className="routine-label">Responder para</label>
            <input className="routine-input" type="email" value={configuracao.responderPara} onChange={(event) => atualizarCampo('responderPara', event.target.value)} placeholder="contato@sistemasvms.com.br" />
          </div>
        </div>

        <div className="routine-field" style={{ marginTop: '16px' }}>
          <label className="routine-label">URL pública exibida no link</label>
          <input className="routine-input" type="url" value={configuracao.urlAcao} onChange={(event) => atualizarCampo('urlAcao', event.target.value)} placeholder="https://painel.sistemasvms.com.br" />
          <p className="routine-callout__text" style={{ marginTop: '8px' }}>
            É a página do PromoAlert que o usuário abrirá para confirmar o e-mail ou redefinir a senha. Exemplo: <code>https://painel.sistemasvms.com.br</code>.
          </p>
        </div>

        <div className="admin-grid-2" style={{ marginTop: '16px' }}>
          <div className="routine-field"><label className="routine-label">Conexão de envio</label><select className="routine-select" value={configuracao.smtp.autenticacao} onChange={(event) => mudarAutenticacao(event.target.value)}><option value="senha">SMTP com usuário e senha</option><option value="microsoft_oauth">Microsoft 365 com autorização segura</option></select></div>
          <div className="routine-field"><label className="routine-label">Servidor SMTP</label><input className="routine-input" value={configuracao.smtp.host} disabled={usaMicrosoft} onChange={(event) => atualizarSmtp('host', event.target.value)} placeholder="smtp.seudominio.com" /></div>
          <div className="routine-field"><label className="routine-label">Porta</label><input className="routine-input" type="number" min="1" max="65535" value={configuracao.smtp.porta} disabled={usaMicrosoft} onChange={(event) => atualizarSmtp('porta', Number(event.target.value))} /></div>
          <div className="routine-field"><label className="routine-label">Usuário SMTP</label><input className="routine-input" value={configuracao.smtp.usuario} onChange={(event) => atualizarSmtp('usuario', event.target.value)} placeholder="noreply@mail.sistemasvms.com.br" /></div>
          <div className="routine-field"><label className="routine-label">Segurança</label><select className="routine-select" value={configuracao.smtp.seguranca} disabled={usaMicrosoft} onChange={(event) => atualizarSmtp('seguranca', event.target.value)}><option value="starttls">STARTTLS (porta 587)</option><option value="ssl">SSL/TLS (porta 465)</option></select></div>
          {!usaMicrosoft && <div className="routine-field"><label className="routine-label">Nova senha SMTP</label><input className="routine-input" type="password" autoComplete="new-password" value={senhaSmtp} onChange={(event) => { setSenhaSmtp(event.target.value); setAlterado(true); }} placeholder={configuracao.smtp?.senhaConfigurada ? 'Deixe em branco para manter a atual' : 'Informe a senha uma única vez'} /></div>}
        </div>

        {usaMicrosoft && <div className="routine-callout" style={{ marginTop: '16px' }}>
          <h5 className="routine-callout__title">Integração Microsoft 365</h5>
          <p className="routine-callout__text" style={{ marginTop: '8px' }}>Use os identificadores do registro Microsoft. A chave fica no segredo <code>promoalert-microsoft-client-secret</code> deste ambiente. Não informe aqui a senha da caixa nem códigos do Authenticator. Autorize somente o envio pela caixa escolhida no Exchange.</p>
          <div className="admin-grid-2" style={{ marginTop: '12px' }}>
            <div className="routine-field"><label className="routine-label">ID do diretório (locatário)</label><input className="routine-input" value={configuracao.smtp.microsoft.tenantId} onChange={(event) => atualizarMicrosoft('tenantId', event.target.value)} /></div>
            <div className="routine-field"><label className="routine-label">ID do aplicativo (cliente)</label><input className="routine-input" value={configuracao.smtp.microsoft.clientId} onChange={(event) => atualizarMicrosoft('clientId', event.target.value)} /></div>
          </div>
        </div>}

        <div className="routine-callout" style={{ marginTop: '16px' }}>
          <h5 className="routine-callout__title">Variáveis disponíveis nos modelos</h5>
          <p className="routine-callout__text" style={{ marginTop: '8px' }}><code>%APP_NAME%</code>, <code>%DISPLAY_NAME%</code>, <code>%EMAIL%</code> e <code>%LINK%</code>. O conteúdo deve usar HTML simples.</p>
        </div>

        {[
          ['verificacao', 'Verificação de e-mail'],
          ['redefinicaoSenha', 'Recuperação de senha'],
        ].map(([chave, titulo]) => (
          <div key={chave} className="routine-callout" style={{ marginTop: '16px' }}>
            <h5 className="routine-callout__title">{titulo}</h5>
            <div className="routine-field" style={{ marginTop: '12px' }}><label className="routine-label">Assunto</label><input className="routine-input" value={configuracao.modelos[chave].assunto} onChange={(event) => atualizarModelo(chave, 'assunto', event.target.value)} /></div>
            <div className="routine-field" style={{ marginTop: '12px' }}><label className="routine-label">Mensagem HTML</label><textarea className="routine-input" style={{ minHeight: '150px', padding: '12px 14px', resize: 'vertical' }} value={configuracao.modelos[chave].corpo} onChange={(event) => atualizarModelo(chave, 'corpo', event.target.value)} /></div>
          </div>
        ))}

        {retorno && <div className={`routine-callout ${retorno.tipo === 'erro' ? 'routine-callout--danger' : 'routine-callout--diamond'}`} style={{ marginTop: '16px' }}><p className="routine-callout__text">{retorno.mensagem}</p></div>}

        <div className="routine-actions" style={{ marginTop: '18px' }}>
          <button type="button" className="routine-btn routine-btn--diamond" onClick={salvar}>{salvando ? 'Salvando...' : 'Salvar configuração de e-mail'}</button>
          <button type="button" className="routine-btn" onClick={enviarTeste} disabled={alterado || !credencialConfigurada || IS_HOMOLOGACAO}>{testando ? 'Enviando...' : 'Enviar teste para meu e-mail'}</button>
        </div>
        <p className="routine-callout__text" style={{ marginTop: '10px' }}>Salve a configuração antes de testar. O teste usa os dados salvos e pode ser feito com o envio para usuários desativado.</p>
      </fieldset>
    </section>
  );
}

export default AbaConfiguracaoEmail;
